<template lang="pug">
div
  ListExceptionsOVG
</template>

<script>
import ListExceptionsOVG from '../components/OVG/ListExceptionsOVG.vue'

export default {
  name: 'ExceptionsOVG',
  components: {
    ListExceptionsOVG,
  },
}
</script>
